import React from "react";
import { useNavigate } from "react-router-dom";
import "./ProductsMobile.css";

import paintBlue from "../assets/paintblue3.png";
import paintPink from "../assets/paintpink3.png";
import ShadesImgBG from "../assets/shadesImg-bg.png";
import PaletteImg from "../assets/paletteImg3.png";
import PaintNavy from "../assets/paintNavy3.png";
import PaintCyan from "../assets/paintCyan3.png";
import PaintRed from "../assets/paintRed3.png";
import GreenBucket from "../assets/paintGloss3.png";
import CategoryImgBG from "../assets/categoryImg-bg.png";

const ProductsMobile = () => {
  const navigate = useNavigate();

  const openProduct = (productId) => {
    navigate(`/products/${productId}`);
  };

  const handleCardKeyDown = (event, productId) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      openProduct(productId);
    }
  };

  return (
    <div className="productsm-containerm">
      <h2 className="productsm-titlem">Our Products</h2>
      <p className="productsm-subtitlem">
        Pakistan’s Top Choice in Locally Manufactured Paints
      </p>

      {/* Product Card 1 */}
      <div
        className="productm-cardm productm-clickable"
        style={{ backgroundColor: "#E4F2F8" }}
        onClick={() => openProduct(1)}
        role="button"
        tabIndex={0}
        onKeyDown={(event) => handleCardKeyDown(event, 1)}
      >
        <div className="productm-contentm">
          <img
            src={paintBlue}
            alt="Plastic Emulsion"
            className="productm-imgm"
          />
          <div className="productm-textm">
            <h3>Plastic Emulsion</h3>
            <p>
              Plastic Emulsion is your everyday hero soft to the touch, smooth
              in finish, and effortlessly elegant. It glides onto walls like
              poetry, leaving behind a breathable coat that feels fresh and
              refined.
            </p>
          </div>
        </div>
      </div>

      {/* Product Card 2 */}
      <div
        className="productm-cardm productm-clickable"
        style={{ backgroundColor: "#F5E0EB" }}
        onClick={() => openProduct(5)}
        role="button"
        tabIndex={0}
        onKeyDown={(event) => handleCardKeyDown(event, 5)}
      >
        <div className="productm-contentm reverse">
          <img
            src={paintPink}
            alt="Plastic Emulsion"
            className="productm-imgm"
          />
          <div className="productm-textm">
            <h3>Aquatic Matt Emulsion</h3>
            <p>
              Aquatic Matt Emulsion is where top-tier craftsmanship meets subtle
              elegance. This water based formula delivers a rich, matte finish
              that feels both modern and timeless.
            </p>
          </div>
        </div>
      </div>

      {/* Shade Card Section */}
      <div className="shadem-cardm">
        <img src={ShadesImgBG} alt="Shade Cards" className="shadem-imgm" />
        <div className="shadem-textm">
          <h3>Browse Our Shade Cards</h3>
          <p>
            Take the guesswork out of painting. Our curated shade cards help you
            explore colour families, combinations, and trending tones.
          </p>
          <button className="shadem-btnm">View All Shades</button>
        </div>
      </div>

      {/* Explore Our Palettes */}
      <div className="palettem-cardm">
        <img
          src={PaletteImg}
          alt="Explore Palettes"
          className="palettem-imgm"
        />
      </div>

      {/* Yellow Section */}
      <div
        className="productm-cardm productm-clickable"
        style={{ backgroundColor: "#FFF7E0" }}
        onClick={() => openProduct(6)}
        role="button"
        tabIndex={0}
        onKeyDown={(event) => handleCardKeyDown(event, 6)}
      >
        <div className="productm-contentm">
          <img
            src={PaintNavy}
            alt="Plastic Emulsion"
            className="productm-imgm"
          />
          <div className="productm-textm">
            <h3>Weather Guard</h3>
            <p>
              Weather Guard stands tall against the elements. From blistering
              sun to monsoon rains, it shields your home with unwavering
              resilience.
            </p>
          </div>
        </div>
      </div>

      <div className="paintm-sectionm">
        <div className="paintm-headerm-cardm">
          <img
            src={CategoryImgBG}
            alt="Paint Category"
            className="paintm-bg-imagem"
          />
          <div className="paintm-headerm-contentm">
            <h3>Choose your paint category</h3>
            <p>
              Explore our premium paint categories and find the perfect shade to
              bring elegance and style to every space.
            </p>
            <button className="paintm-buttonm">View All Shades</button>
          </div>
        </div>

        <div
          className="productm2-cardm2 productm-clickable"
          style={{ backgroundColor: "#E4F2F8" }}
          onClick={() => openProduct(7)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => handleCardKeyDown(event, 7)}
        >
          <div className="productm2-contentm2">
            <img
              src={PaintCyan}
              alt="Plastic Emulsion"
              className="productm2-imgm2"
            />
            <div className="productm2-textm2">
              <h3>Aquatic Wall Sealer</h3>
              <p>
                Before the beauty begins, Aquatic Wall Sealer lays the
                foundation. It penetrates deep, locking out moisture and locking
                in strength. With superior adhesion and a painter’s ease, it
                prepares your surface for lasting brilliance.
              </p>
            </div>
          </div>
        </div>

        <div
          className="productm2-cardm2 productm-clickable"
          style={{ backgroundColor: "#F5E0EB" }}
          onClick={() => openProduct(2)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => handleCardKeyDown(event, 2)}
        >
          <div className="productm2-contentm2 reverse">
            <img
              src={PaintRed}
              alt="Plastic Emulsion"
              className="productm2-imgm2"
            />
            <div className="productm2-textm2">
              <h3>High Class Emulsion</h3>
              <p>
                High Class Emulsion is luxury in liquid form. Rich in texture,
                radiant in finish, it transforms ordinary spaces into elegant
                expressions. Washable, durable, and deeply refined, it’s made
                for those who see walls as part of their story.
              </p>
            </div>
          </div>
        </div>
        <div
          className="productm2-cardm2 productm-clickable"
          style={{ backgroundColor: "#E4F2F8" }}
          onClick={() => openProduct(4)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => handleCardKeyDown(event, 4)}
        >
          <div className="productm2-contentm2">
            <img
              src={GreenBucket}
              alt="Plastic Emulsion"
              className="productm2-imgm2"
            />
            <div className="productm2-textm2">
              <h3>Gloss Enamel</h3>
              <p>
                Gloss Enamel is bold, brilliant, and built to last. Its mirror
                like shine adds charm to doors, windows, and metal surfaces,
                while its tough formula resists wear and tear.
              </p>
            </div>
          </div>
        </div>

        <button className="paintm-buttonm">View All Shades</button>
      </div>
    </div>
  );
};

export default ProductsMobile;
